import { LassoSelectionStates } from "types/lasso";

import { getStackedBarChartFilteredItems } from "./utils";

export function getStackedBarList({ params, series }: Partial<LassoSelectionStates>) {
  const list = getStackedBarChartFilteredItems(params, series);
  return list;
}
